import React, { useState, useEffect } from 'react';
import './EmailPopup.css';

const EmailPopup = ({ open, onClose, onSubmit, product }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const isValidEmail = (email) => /.+@.+\..+/.test(email);

  useEffect(() => {
    if (open) {
      setEmail('');
      setError('');
    }
  }, [open]);

  const handleContinue = () => {
    if (!isValidEmail(email)) {
      setError('Enter a valid email');
      return;
    }
    setError('');
    onSubmit(email, product);
  };

  if (!open) return null;

  return (
    <div className="email-popup-overlay">
      <div className="email-popup-form">
        <h3>Enter your Email</h3>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          style={{marginBottom: '1rem', padding: '0.5rem', width: '100%'}}
        />
        {error && <div style={{color: 'red', marginBottom: '0.5rem', textAlign: 'center'}}>{error}</div>}
        <button
          className="email-popup-btn"
          onClick={handleContinue}
          disabled={!isValidEmail(email)}
          style={{width: '100%', padding: '0.75rem', background: 'var(--primary-green)', color: '#fff', border: 'none', borderRadius: '30px', fontWeight: 'bold', fontSize: '1rem', marginBottom: '1rem', opacity: isValidEmail(email) ? 1 : 0.5, cursor: isValidEmail(email) ? 'pointer' : 'not-allowed'}}
        >
          Continue to Payment
        </button>
        <button onClick={onClose} style={{background: 'none', border: 'none', color: '#888', cursor: 'pointer'}}>Cancel</button>
      </div>
    </div>
  );
};

export default EmailPopup; 